import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import configureStore from './store';
import { Route, IndexRoute, Router, browserHistory } from 'react-router';

import { Authenticated, NotAuthenticated, AuthenticatedAdmin, AuthenticatedEnabled, AuthenticatedExpired } from './components/AuthenticatedRoute';

import App from './containers/App/App';
import Home from './containers/Home/Home';
import Account from './containers/Account/Account';
import Login from './containers/Login/Login';
import Recover from './containers/Recover/Recover';
import NotFound from './containers/NotFound/NotFound';
import Signup from './containers/Signup/Signup';
import Admin from './containers/Admin/Admin';

import Customers from './containers/Customers/Customers';
import Orders from './containers/Orders/Orders';
import Products from './containers/Products/Products';
import Classrooms from './containers/Classrooms/Classrooms';
import Users from './containers/Users/Users';
import Metrics from './containers/Metrics/Metrics';
import StudentMetrics from './containers/StudentMetrics/StudentMetrics';
import SupplementalMaterials from './containers/SupplementalMaterials/SupplementalMaterials';
import TermsConditions from './containers/TermsConditions/TermsConditions';
import TrialExpired from './containers/TrialExpired/TrialExpired';
import UIKit from './containers/UIKit/UIKit';
import UIGrid from './containers/UIGrid/UIGrid';

const initialState = window.__INITIAL_STATE__ || {firebase: { authError: null }};

let store = configureStore(initialState, browserHistory);

ReactDOM.render(
	<Provider store={store}>
		<Router history={browserHistory}>
			<Route path='/login' component={NotAuthenticated(Login)} />
			<Route path='/recover-password' component={Recover} />
			<Route path='/signup' component={Signup} />
            <Route path='/trialexpired' component={TrialExpired} />
			<Route path='/' component={Authenticated(AuthenticatedExpired(App))}>
				<IndexRoute component={Authenticated(Home)} />

				<Route path='/orders'  component={Authenticated(AuthenticatedAdmin(Orders))} />
				<Route path='/customers'  component={Authenticated(AuthenticatedAdmin(Customers))} />

				<Route path='/account'  component={Authenticated(Account)} />
				<Route path='/products'  component={Authenticated(AuthenticatedEnabled(Products))} />
				<Route path='/classrooms'  component={Authenticated(AuthenticatedEnabled(Classrooms))} />
				<Route path='/users' component={Authenticated(AuthenticatedEnabled(Users))} />
				<Route path='/metrics' component={Authenticated(AuthenticatedEnabled(Metrics))} />
				<Route path='/metrics/:classroomId' component={Authenticated(AuthenticatedEnabled(Metrics))} />
				<Route path='/studentmetrics/' component={Authenticated(AuthenticatedEnabled(StudentMetrics))} />
				<Route path='/studentmetrics/:classroomId/:studentId' component={Authenticated(AuthenticatedEnabled(StudentMetrics))} />
				<Route path='/supplementalmaterials' component={Authenticated(AuthenticatedEnabled(SupplementalMaterials))} />
				<Route path='/TermsConditions' component={Authenticated(AuthenticatedEnabled(TermsConditions))} />


				<Route path='/admin' authorize={['admin']} component={Authenticated(AuthenticatedAdmin(Admin))} />
				<Route path='*' component={NotFound} />
			</Route>
		</Router>
	</Provider>,
	document.getElementById('root')
);





// WEBPACK FOOTER //
// ./js/application.js